import { render, staticRenderFns } from "./CheckboxSelect.vue?vue&type=template&id=83764a4e&scoped=true"
import script from "./CheckboxSelect.vue?vue&type=script&lang=js"
export * from "./CheckboxSelect.vue?vue&type=script&lang=js"
import style0 from "./CheckboxSelect.vue?vue&type=style&index=0&id=83764a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83764a4e",
  null
  
)

export default component.exports